import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import './ErrorRender.css';

/**
 * Maps a redux-form field error to its dictionary key.
 * @param {Object} props - The redux-form field props (input, meta, category).
 * @returns {{fieldId: string, className: string}|null} The key to show, or null when there is
 *   nothing to report.
 * @author armandoricosandoval -ai-
 */
const resolveErrorKey = (props) => {
  if (typeof props.input === 'undefined') {
    return null;
  }

  let fieldId = `com.tempedge.error.${props.category}.${props.input.name}required`;
  let className = '';

  if (fieldId === 'com.tempedge.error.person.usernamerequired' || fieldId === 'com.tempedge.error.person.passwordrequired') {
    className = 'text-left';
  }

  switch (props.meta.error) {
    case 'Password does not match.':
      if (props.input.name === 'initialpassword' || props.input.name === 'confirmpassword') {
        fieldId = 'com.tempedge.error.passwordnomatch';
      }
      break;
    case 'Please enter a valid password (8 characters, alphanumeric).':
      if (props.input.name === 'initialpassword' || props.input.name === 'confirmpassword') {
        fieldId = 'com.tempedge.error.passwordnotvalid';
      }
      break;
    case 'Please enter a phone number.':
      fieldId = 'com.tempedge.error.phonenumberrequired';
      break;
    case 'Name is required.':
      fieldId = 'com.tempedge.error.officeNamerequired';
      break;
    case 'Address is required.':
      fieldId = 'com.tempedge.error.addressrequired';
      break;
    case 'City is required.':
      fieldId = 'com.tempedge.error.cityrequired';
      break;
    case 'Zip code is required.':
      fieldId = 'com.tempedge.error.zipcoderequired';
      break;
    case 'State is required.':
      fieldId = 'com.tempedge.error.staterequired';
      break;
    case 'Country is required.':
      fieldId = 'com.tempedge.error.countryrequired';
      break;
    case 'Email field is required.':
      fieldId = 'com.tempedge.error.person.emailrequired';
      break;
    case 'Invalid email address.':
      fieldId = 'com.tempedge.error.person.emailrequired';
      break;
    case props.meta.error?.type:
      fieldId = 'com.tempedge.msg.label.filetype';
      break;
    case props.meta.error?.file:
      fieldId = 'com.tempedge.msg.label.filename';
      break;
    default:
      fieldId = 'com.tempedge.error.required';
  }

  if (props.meta.touched && props.meta.error && typeof props.meta.error !== 'undefined') {
    return { fieldId, className };
  }

  return null;
};

/**
 * Shows the validation error of a redux-form field, translated.
 * @param {Object} props - The redux-form field props (input, meta, category).
 * @returns {JSX.Element|null} The error line, or null when the field has nothing to report.
 * @author armandoricosandoval -ai-
 */
const RenderError = (props) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();
  const resolved = resolveErrorKey(props);

  if (!resolved) {
    return null;
  }

  return <p className={`errorrender-message ${resolved.className}`.trim()}>{tempedgeTranslator(resolved.fieldId)}</p>;
};

export default RenderError;
